import React, { Fragment } from 'react'

import TextField from '@material-ui/core/TextField'

/* atoms */
import { Invalid } from '../feedbacks'
/* atoms */

/* function */
import inputErrorCleaner from './_input_error_cleaner'
/* function */

/*
: properties
name,
label,
value,
onChange,
helperText,
error
*/

const textarea = (props) => {
  return (
    <Fragment>
      <TextField
        {...props}
        fullWidth
        multiline
        variant="outlined"
        margin="dense"
        className="subway-six-inch"
      />
      <Invalid {...props} />
    </Fragment>
  )
}

export default textarea
